import { head } from "lodash";
import { joinStringsWithComma } from "./string";
export const getAddressLine = ({
  organisation,
  street,
  property,
  locality,
  town
}) => joinStringsWithComma([organisation, street, property, town, locality]);
export const getAddressWithPostcode = address => joinStringsWithComma([getAddressLine(address), address.postcode]);
export const getPropertyNumber = address => head(address.property.match(/\d+/g));
export const sortAddresses = addresses => addresses.sort((addressOne, addressTwo) => addressOne.street === addressTwo.street ? getPropertyNumber(addressOne) - getPropertyNumber(addressTwo) : addressOne.street > addressTwo.street ? 1 : -1);